import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';
import { openModal } from '~/cards/actions/modalActions';
import ApiService from '../../../util/api';
import ActionTypes from '../projectActionTypes';

// Selectors
import { getProjectUUID } from '../../selectors/cardProjectSelector';

function requestAddProjectToCart() {
  return {
    type: ActionTypes.REQUEST_ADD_PROJECT_TO_CART,
  };
}

function receiveAddProjectToCart() {
  return {
    type: ActionTypes.RECEIVE_ADD_PROJECT_TO_CART,
  };
}

export const addProjectToCartErrorHandling = (e, dispatch) => {
  try {
    e.response
      .json()
      .then((data) => {
        if (data && data.error && data.error.errors[0].code === 1001) {
          dispatch(
            openModal(
              'PROOF_LIMIT_MODAL',
              {},
              {
                size: 'xs',
                bottomModalOnMobile: true,
                className: 'proofModalContainer',
              }
            )
          );
        } else {
          dispatch(
            toastsActions.negative({
              headline: 'Unable to add to cart. Please try again.',
            })
          );
        }
      })
      .catch(() => {
        dispatch(
          toastsActions.negative({
            headline: 'Unable to add to cart. Please try again.',
          })
        );
      });
  } catch (e2) {
    dispatch(
      toastsActions.negative({
        headline: 'Unable to add to cart. Please try again.',
      })
    );
  }
};

// function that handles using v1 endpoint for projects with old sku model or v3 endpoint
// for projects with new sku model - with this action conditional logic doesnt have to be
// implemented in components
export function addProjectToCart(isCustomizable = true) {
  return (dispatch, getState) => {
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const requestBody = {
      projectUUID,
    };
    dispatch(requestAddProjectToCart());
    return (
      ApiService.post(`/web-api/v4/card-project/cart`, requestBody, {}, {}, 'text')
        .then(() => {
          if (isCustomizable) {
            window.location = `/wedding-planning/cart/${projectUUID}/confirmation`;
          } else {
            window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
          }
        })
        .catch((e) => addProjectToCartErrorHandling(e, dispatch))
        // Bascially means we aren't submitting anymore
        .finally(() => dispatch(receiveAddProjectToCart()))
    );
  };
}

export const quickAddProjectToCart = (projectUUID) => {
  return (dispatch) => {
    if (!projectUUID) return Promise.resolve(null);

    const requestBody = {
      projectUUID,
    };
    dispatch(requestAddProjectToCart());
    return ApiService.post(`/web-api/v4/card-project/cart`, requestBody, {}, {}, 'text')
      .then(() => dispatch(receiveAddProjectToCart()))
      .then(() => {
        window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
      })
      .catch((e) => addProjectToCartErrorHandling(e, dispatch));
  };
};
